<template>
  <div class="background-modal align-modal" id="outModal" @keyup.esc="dismissModal">
      <div class="content">
          <div class="header">
              <div id="header-row">
                  <p id="header-title">Detalhes do contato</p>
                  <i class="fas fa-times" id="close-button" @click="dismissModal"></i>
              </div>
          </div>
          <div class="body">
              <div id="img-container">
                  <img :src="avatarSrc" @error="setDefaultAvatar" />
              </div>
              <div id="details-container">
                  <div class="custom-input-group">
                      <label for="name">Nome</label>
                      <input type="text" class="form-control" name="name" id="name" v-model="updateData.name" required
                          :disabled="disable">
                  </div>
                  <div class="custom-input-group">
                      <label>{{ contactType === 'telefone' ? 'Telefone' : 'Ramal' }}</label>
                      <div class="contact-wrapper">
                          <!-- Campo TELEFONE -->
                          <vue-tel-input v-if="contactType === 'telefone'" id="phone-input"
                              :inputOptions="optionsTelInput" mode="international" v-model="updateData.phone"
                              :default-country="'BR'" required :disabled="disable" />
                          <!-- Campo RAMAL -->
                          <input v-else type="text" id="ramal-input" class="form-control ramal-input"
                              v-model="updateData.phone" :disabled="disable" maxlength="4" pattern="[0-9]*"
                              placeholder="Digite o Ramal" />
                          <!-- Botão de alternância -->
                          <button class="btn-toggle" @click="toggleContactType" :disabled="disable"
                              :title="contactType === 'telefone' ? 'Trocar para Ramal' : 'Trocar para Telefone'">
                              <i :class="contactType === 'telefone' ? 'fas fa-toggle-on' : 'fas fa-toggle-off'"></i>
                          </button>
                      </div>
                  </div>

                  <div class="custom-input-group">
                      <label for="cnpj">CPF / CNPJ / ID</label>
                      <the-mask class="form-control campoTel" name="cnpj" id="cnpj" v-model="updateData.unique_key"
                          :disabled="disable" required :mask="['###.###.###-##', '##.###.###/####-##']"
                          placeholder="CPF ou CNPJ" />
                  </div>
              </div>
          </div>
          <div>
              <div id="button-group">
                  <button v-if="disable" @click="enableEdit" class="btn btn-info cursor-pointer">
                      <i class="fa fa-edit"></i> Editar
                  </button>
                  <template v-else>
                      <button @click="updateCl" class="btn btn-success cursor-pointer">
                          <i class="fa fa-save"></i> Salvar
                      </button>
                      <button @click="deleteCl" class="btn btn-danger cursor-pointer">
                          <i class="fa fa-trash"></i> Excluir
                      </button>
                      <button @click="disableEdit" class="btn btn-secondary cursor-pointer">
                          <i class="fa fa-times"></i> Cancelar
                      </button>
                  </template>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios';
import { TheMask } from 'vue-the-mask';

export default {
  components: { TheMask },
  props: {
      data: { type: Object }
  },
  data() {
      return {
          show: true,
          disable: true,
          avatarSrc: "/imgs/default-profile.png",
          contactType: this.data.phone.length <= 4 ? 'ramal' : 'telefone',
          telefone: this.data.phone.length > 4 ? this.data.phone : '',
          ramal: this.data.phone.length <= 4 ? this.data.phone : '',
          updateData: {
              name: this.data.name,
              phone: this.data.phone,
              unique_key: this.data.unique_key,
          },
          optionsTelInput: {
              placeholder: 'Insira o telefone',
              required: true,
          }
      };
  },
  mounted() {
      document.addEventListener('keyup', this.onClick);
  },
  destroyed() {
      document.removeEventListener('keyup', this.onClick);
  },
  methods: {
      toggleContactType() {
            if (this.contactType === 'telefone') {
                this.telefone = this.updateData.phone; // guarda o telefone
                this.updateData.phone = this.ramal || ''; // restaura ramal, se houver
                this.contactType = 'ramal';
            } else {
                this.ramal = this.updateData.phone; // guarda o ramal
                this.updateData.phone = this.telefone || ''; // restaura telefone, se houver
                this.contactType = 'telefone';
            }
        },
      setDefaultAvatar(event) {
          event.target.src = "/imgs/default-whatsapp.png";
      },
      enableEdit() {
          this.disable = false;
      },
      disableEdit() {
          this.disable = true;
      },
      onClick(e) {
          if (e.key === 'Escape') this.dismissModal();
      },
      dismissModal() {
          this.$emit('dismissModal');
      },
      deleteCl() {
          axios.post('/customer_base/destroy', { id: this.data.id }).then(() => {
              Swal.fire(
                  'Registro Excluído',
                  'Este cliente não faz mais parte de sua base',
                  'success'
              ).then(() => this.dismissModal());
          });
      },
      updateCl() {
          axios.post('/customer_base/save', {
              id: this.data.id,
              name: this.updateData.name,
              phone: this.updateData.phone,
              unique_key: this.updateData.unique_key,
          }).then(() => {
              Swal.fire(
                  'Atualização realizada',
                  'Os dados deste cliente foram atualizados',
                  'success'
              ).then(() => this.dismissModal());
          });
      }
  }
};
</script>

<style scoped>
.contact-wrapper {
  position: relative;
  width: 100%;
}

.vue-tel-input input,
.ramal-input {
  padding-right: 40px !important;
}

/* Botão de troca fixado no canto direito do campo */
.btn-toggle {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-45%);
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10;
}

.btn-toggle i {
  color: #007a8a;
  font-size: 25px;
}

.btn-toggle:hover i {
  color: #005f66;
}

.background-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  background-color: #fff;
  width: 100%;
  max-width: 650px;
  border-radius: 12px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  padding: 20px;
}

#header-row {
  display: flex;
  justify-content: space-between;
  background-color: #1c869a;
  border-top: 3px solid #f38630;
}

#header-title {
  color: white;
  font-weight: bold;
  margin: 5px 20px;
  align-self: center;
}

#close-button {
  font-weight: bolder;
  background-color: white;
  color: #aa1a1a;
  cursor: pointer;
  border: 1px solid #aa1a1a;
  border-radius: 10px !important;
  padding: 8px;
  align-self: center;
  margin: 5px;
}

#close-button:hover {
  color: #ff6b6b;
}

.body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

#img-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

#img-container img {
  border-radius: 50%;
  height: 100px;
  width: 100px;
  border: 2px solid #eaeaea;
  object-fit: cover;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
}

#details-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  width: 100%;
}

.custom-input-group,
.input-group {
  display: flex;
  flex-direction: column;
}

.custom-input-group label,
.input-group label {
  font-weight: bold;
  color: #333;
  font-size: 13px;
  margin-bottom: 5px;
}

.custom-input-group input,
.input-group input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px !important;
  font-size: 14px;
  transition: 0.3s;
}

.vue-tel-input {
  width: 100%;
}

.vue-tel-input input {
  height: 38px;
  font-size: 14px;
  border-radius: 6px !important;
  border: 1px solid #ccc;
  padding: 8px;
}

.vue-tel-input:focus-within input {
  border-color: #007a8a;
  box-shadow: 0 0 5px rgba(0, 122, 138, 0.5);
}

#button-group {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 25px;
}

#button-group button {
  padding: 8px 12px;
  border: none;
  border-radius: 6px !important;
  font-size: 14px;
  cursor: pointer;
  transition: 0.3s;
  min-width: 100px;
}

.btn-success {
  background-color: #2d6a4f;
  color: white;
}

.btn-success:hover {
  background-color: #1b4332;
}

.btn-danger {
  background-color: #d00000;
  color: white;
}

.btn-danger:hover {
  background-color: #9b0000;
}

.btn-info {
  background-color: #007a8a;
  color: white;
}

.btn-info:hover {
  background-color: #005f66;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #545b62;
}

/* Responsivo para telas menores */
@media (max-width: 600px) {
  #details-container {
      grid-template-columns: 1fr;
  }

  .content {
      padding: 15px;
  }
}

.contact-flex {
  display: flex;
  gap: 10px;
  align-items: center;
}

.contact-type-select {
  flex: 1;
}

.contact-input {
  flex: 2;
}

.contact-type-select select {
  width: 100%;
  padding: 8px;
  font-size: 14px;
  border-radius: 6px !important;
  border: 1px solid #ccc;
}
</style>
